import { FormattedValue } from "../models/value-formatting";
import Decimal from "decimal.js";

export const SI_UNIT_MAP: { suffix: string; threshold: number }[] = [
  { suffix: "Y", threshold: 1e24 },
  { suffix: "Z", threshold: 1e21 },
  { suffix: "E", threshold: 1e18 },
  { suffix: "P", threshold: 1e15 },
  { suffix: "T", threshold: 1e12 },
  { suffix: "B", threshold: 1e9 },
  { suffix: "M", threshold: 1e6 },
  { suffix: "K", threshold: 1e3 },
  { suffix: "", threshold: 1 },
];
export const SI_SIZES: string[] = ["Bytes", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
export const EMPTY_BYTES: FormattedValue = {
  unit: SI_SIZES[0],
  decimal: new Decimal(0),
  value: 0,
  fmt: "0",
};
export const EMPTY_VAL: FormattedValue = {
  unit: "",
  fmt: "0",
  decimal: new Decimal(0),
  value: 0,
};
export const TEMPL_VAR_REGEX = /\{[^}]+}/g;
export const PLACEHOLDER_REGEX = /([{]([^}]+)[}])/g;
export const REGEX_AWS_SERVICE = /^A(WS|mazon) */i;
export const CONSISTENT_COLORS: { [label: string]: string } = {};
export const LETTERS = "0123456789ABCDEF";
export const WORD_REGEX = /[a-z]{2,}/gi;
export const VODAFONE_DOMAIN_REGEX = /^[^@]+@(voda|vantage).*$/i;
